import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
import PopupSearch from "../components/PopupSearch";
import ScrollToTop from "../components/ScrollToTop";

const CancelOrder = () => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleCancelClick = () => {
    setShowConfirm(true);
  };

  const handleConfirmCancel = () => {
    setShowConfirm(false);
    setShowSuccess(true);
  };

  const handleGoToOrders = () => {
    setShowSuccess(false);
    navigate("/my-orders");
  };

  return (
    <>
      <MobileMenu />
      <PopupSearch />

      <main className="main">

        <Header />

        {/* CSS */}
        <link rel="stylesheet" href="/assets/css/Cancelorder.css" />

        {/* BREADCRUMB */}
        <div
          className="breadcumb-wrapper"
          style={{
            backgroundImage: "url('/assets/img/bg/breadcumb-bg-1.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <img
            src="/assets/img/shapes/dot-shape.svg"
            alt="dot"
            className="breadcumb-element"
          />
          <div className="container">
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">Cancel Order</h1>
              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li><Link to="/">Home</Link></li>
                  <li>Cancel Order</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* MAIN SECTION */}
        <section className="space-top space-extra-bottom cancel-order-section">
          <div className="container">

            {/* TOP */}
            <div className="cancel-top">
              <div>
                <h2 className="cancel-title">Cancel Order</h2>
                <p className="order-info">
                  Order ID: #NS-1045
                  <span>•</span>
                  Placed on: 20 Apr 2026
                </p>
              </div>
              <div className="cancel-badge">
                <i className="bi bi-info-circle"></i>
                Cancellation is allowed before shipping
              </div>
            </div>

            {/* WRAPPER */}
            <div className="cancel-wrapper">

              {/* LEFT */}
              <div className="cancel-left">

                {/* ORDER SUMMARY */}
                <div className="cancel-card">
                  <h4>Order Summary</h4>

                  <div className="product-item">
                    <div className="product-img">
                      <img src="/assets/img/product3/product-s-1-1.png" alt="" />
                    </div>
                    <div className="product-content">
                      <h5>Petal Perfection Ring</h5>
                      <p>Qty: 1 | ₹4,500</p>
                    </div>
                    <div className="product-price">₹4,500</div>
                  </div>

                  <div className="product-item border-0">
                    <div className="product-img">
                      <img src="/assets/img/product3/product-s-1-3.png" alt="" />
                    </div>
                    <div className="product-content">
                      <h5>Diamond Stud Earrings</h5>
                      <p>Qty: 1 | ₹6,800</p>
                    </div>
                    <div className="product-price">₹6,800</div>
                  </div>
                </div>

                {/* CANCEL REASON */}
                <div className="cancel-card mt-4">
                  <h4>Why are you cancelling this order?</h4>

                  <div className="cancel-reason">
                    <label className="reason-item">
                      <input type="checkbox" />
                      <span>Changed my mind</span>
                    </label>
                    <label className="reason-item">
                      <input type="checkbox" />
                      <span>Ordered by mistake</span>
                    </label>
                    <label className="reason-item">
                      <input type="checkbox" />
                      <span>Found a better price</span>
                    </label>
                    <label className="reason-item">
                      <input type="checkbox" />
                      <span>Delivery taking too long</span>
                    </label>
                    <label className="reason-item">
                      <input type="checkbox" />
                      <span>Other reason</span>
                    </label>
                  </div>

                  <textarea
                    className="form-control mt-3"
                    placeholder="Tell us more (optional)..."
                  ></textarea>

                  <div className="refund-note">
                    <i className="bi bi-shield-check"></i>
                    Your payment will be refunded to your original payment method.
                  </div>
                </div>

              </div>

              {/* RIGHT */}
              <div className="cancel-right">

                {/* PRICE */}
                <div className="cancel-card">
                  <div className="price-row">
                    <span>Subtotal (2 items)</span>
                    <span>₹11,300</span>
                  </div>
                  <div className="price-row">
                    <span>Shipping</span>
                    <span>Free</span>
                  </div>
                  <div className="price-row">
                    <span>Discount</span>
                    <span className="text-success">-₹500</span>
                  </div>
                  <div className="price-row total">
                    <span>Total</span>
                    <span>₹10,800</span>
                  </div>
                </div>

                {/* REFUND INFO */}
                <div className="cancel-card refund-card mt-4">
                  <h4>
                    <i className="bi bi-wallet2"></i>
                    Refund Information
                  </h4>
                  <p><i className="bi bi-clock"></i> Refund will be initiated within 24–48 hours</p>
                  <p><i className="bi bi-calendar-check"></i> Amount will be credited in 3–7 business days</p>
                  <p><i className="bi bi-credit-card"></i> Refund to original payment method</p>
                </div>

                {/* NOTE */}
                <div className="cancel-note mt-4">
                  <i className="bi bi-info-circle"></i>
                  Once the order is shipped, it cannot be canceled.
                </div>

              </div>
            </div>

            {/* BUTTONS */}
            <div className="cancel-btns">
              <Link to="/my-orders" className="vs-btn style2 track-order-custom track-order">
                Back to Orders
              </Link>
              <button
                type="button"
                className="vs-btn cancel-red-btn cancel-red-btn-custom cancel-red-btn"
                onClick={handleCancelClick}
              >
                Cancel Order
              </button>
            </div>

          </div>
        </section>

        <Footer />
      </main>

      <ScrollToTop />

      {/* ── CONFIRM POPUP ── */}
      {showConfirm && (
        <div className="co-overlay">
          <div className="co-popup co-confirm">

            <div className="co-icon warn">
              <i className="bi bi-exclamation-triangle-fill"></i>
            </div>

            <h2>Cancel This Order?</h2>

            <p className="co-sub">
              Are you sure you want to cancel order <strong>#NS-1045</strong>?
              This action cannot be undone.
            </p>

            <div className="co-order-box">
              <div className="co-order-row">
                <span>2 items</span>
                <span>₹11,300</span>
              </div>
              <div className="co-order-row refund-row">
                <span><i className="bi bi-arrow-counterclockwise"></i> Refund Amount</span>
                <span className="refund-amt">₹10,800</span>
              </div>
            </div>

            <p className="co-timer">
              <i className="bi bi-clock"></i>
              Refund will be processed within 3–7 business days.
            </p>

            <div className="co-btn-group">
              <button
                className="co-btn co-btn-ghost"
                onClick={() => setShowConfirm(false)}
              >
                No, Keep Order
              </button>
              <button
                className="co-btn co-btn-red"
                onClick={handleConfirmCancel}
              >
                Yes, Cancel Order
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ── SUCCESS POPUP ── */}
      {showSuccess && (
        <div className="co-overlay">
          <div className="co-popup co-success">

            <div className="co-icon green">
              <i className="bi bi-check-lg"></i>
            </div>

            <h2>Order Cancelled!</h2>

            <p className="co-sub">
              Your order <strong>#NS-1045</strong> has been successfully cancelled.
            </p>

            <div className="co-order-box">
              <div className="co-order-row">
                <span><i className="bi bi-wallet2"></i> Refund Amount</span>
                <span className="refund-amt">₹10,800</span>
              </div>
              <div className="co-order-row">
                <span><i className="bi bi-calendar-check"></i> Credited in</span>
                <span>3–7 business days</span>
              </div>
              <div className="co-order-row">
                <span><i className="bi bi-credit-card"></i> To</span>
                <span>Original payment method</span>
              </div>
            </div>

            <p className="co-timer">
              <i className="bi bi-envelope"></i>
              A confirmation email has been sent to you.
            </p>

            <div className="co-btn-group">
              <Link
                to="/shop"
                className="co-btn co-btn-ghost"
                onClick={() => setShowSuccess(false)}
              >
                Continue Shopping
              </Link>
              <button
                className="co-btn co-btn-dark"
                onClick={handleGoToOrders}
              >
                View My Orders
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default CancelOrder;
